export function getVideoWidgetItemUrl(videoWidget) {
  return videoWidget.object.item_url || videoWidget.position.data.item_url;
}

export function getVideoWidgetItemId(videoWidget) {
  return videoWidget.object.item_id || videoWidget.position.data.item_id;
}
